module.exports = __webpack_public_path__ + "media/images/top/title_kvSP-36752456260947131d4d6b61655a74c8.svg";